module.exports = __webpack_public_path__ + "img/logo-lg.c10ba67e.svg";